import { render, staticRenderFns } from "./cancleOrder.vue?vue&type=template&id=05474a2a&scoped=true"
import script from "./cancleOrder.vue?vue&type=script&lang=js"
export * from "./cancleOrder.vue?vue&type=script&lang=js"
import style0 from "./cancleOrder.vue?vue&type=style&index=0&id=05474a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05474a2a",
  null
  
)

export default component.exports